module.exports = __webpack_public_path__ + "img/leopard.b45451bf.jpg";